module.exports = __webpack_public_path__ + "img/program-apply.f629a5f9.jpg";